import axios from 'axios';
import { API_DATABASE_URL } from './base_url';
export const http = axios.create({
	baseURL: API_DATABASE_URL.API_RAVITY,
	timeout: 60000,
	headers: {
		Accept: '*/*',
		'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
	},
});

export const httpRest = axios.create({
	baseURL: API_DATABASE_URL.API_REST_RAVITY,
	timeout: 60000,
	headers: {
		Accept: '*/*',
		'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
	},
});

export const httpwithtoken = axios.create({
	baseURL: API_DATABASE_URL.API_RAVITY,
	timeout: 60000,
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
	},
});

// Read the token on every request so it is never stale after login/logout.
httpwithtoken.interceptors.request.use((config) => {
	const token = localStorage.getItem('token');
	if (token) config.headers.Authorization = `Bearer ${token}`;
	return config;
});

export const httpJson = axios.create({
	baseURL: API_DATABASE_URL.API_RAVITY_INGESTION,
	timeout: 60000,
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
	},
});


export const httpIot = axios.create({
   baseURL: 'https://iot.ravity.io',
// baseURL: 'http://localhost:3000/iot-proxy', 
  timeout: 60000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export function getAbortController() {
	return new AbortController();
  }